/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mock_HintInputs */

const cs_auth_mock_hint = /** @type {(inputs: Auth_Mock_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mock: admin@ / lead@ / external@ / assist@ mění roli; libovolné heslo.`)
};

const en_auth_mock_hint = /** @type {(inputs: Auth_Mock_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mock: admin@ / lead@ / external@ / assist@ changes role; any password.`)
};

/**
* | output |
* | --- |
* | "Mock: admin@ / lead@ / external@ / assist@ changes role; any password." |
*
* @param {Auth_Mock_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mock_hint = /** @type {((inputs?: Auth_Mock_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mock_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_mock_hint(inputs)
	return cs_auth_mock_hint(inputs)
});